import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import State from '../states'
import Header, { Props } from '../components/Header'
import { Login } from '../actions'

const mapStateToProps = (state: State): Partial<Props> => ({
  username: state.login.user
    ? !state.login.user.guest ? state.login.user.username : undefined
    : undefined,
  loginLoading: state.login.loginLoading,
  loginModal: state.login.loginModal,
  loginErrors: state.login.loginErrors,
  signUpLoading: state.login.signUpLoading,
  signUpModal: state.login.signUpModal,
  signUpErrors: state.login.signUpErrors
})

const mapDispatchToProps = (dispatch: Dispatch<State>): Partial<Props> => ({
  onLoginClick: () => {
    dispatch(Login.loginClick())
  },
  onLoginClose: () => {
    dispatch(Login.loginClose())
  },
  onLoginSubmit: (usernameOrEmail: string, password: string) => {
    dispatch(
      Login.login.started({
        usernameOrEmail,
        password
      })
    )
  },
  onSignUpClick: () => {
    dispatch(Login.signUpClick())
  },
  onSignUpClose: () => {
    dispatch(Login.signUpClose())
  },
  onSignUpSubmit: (username: string, email: string, password: string) => {
    dispatch(
      Login.signUp.started({
        username,
        email,
        password
      })
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Header.ts